/**
 * Utility functions for history log data processing
 */

/**
 * Helper function to safely parse JSON data from entity
 * @param {string} jsonString - JSON string to parse
 * @returns {Object|null} Parsed object or null if parsing fails
 */
export const parseEntityData = (jsonString) => {
  try {
    if (!jsonString) return null;
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Error parsing JSON data:", error);
    return null;
  }
};

/**
 * Extract campaign details from entity data
 * @param {Object} entity - Entity object containing data
 * @returns {Object} Campaign details with parsed information
 */
export const extractCampaignDetails = (entity) => {
  if (!entity)
    return {
      campaignName: "-",
      campaignTitleShort: "-",
      campaignType: "-",
      subType: "-",
      entitySubType: "-",
      entityData: null,
    };

  const entityData = parseEntityData(entity.data);
  const subType = entityData?.sub_type || entity.subType || "-";

  // Determine entitySubType based on subType value
  let entitySubType = "-";
  if (subType === "page-content") {
    entitySubType = entityData?.content_data?.content_type || "-";
  } else if (subType === "survey-quiz-content") {
    entitySubType = entityData?.content_data?.type || "-";
  } else if (subType === "banner-content") {
    entitySubType = entityData?.content_data?.banner_type || "-";
  } else {
    // Fallback to original logic for other subTypes
    entitySubType = entityData?.entity_sub_type || "-";
  }

  return {
    campaignName: entityData?.title || entity.name || "-",
    campaignTitleShort: entityData?.title_short || "-", // Only use title_short, don't fallback to entity.name
    campaignType: entityData?.definition_slug || entity.subType || "-",
    subType: subType,
    entitySubType: entitySubType,
    entityData,
  };
};

/**
 * Get campaign title short from entity
 * @param {Object} entity - Entity object
 * @returns {string} Campaign short title or fallback
 */
export const getCampaignTitleShort = (entity) => {
  if (!entity) return "-";

  const entityData = parseEntityData(entity.data);
  return entityData?.title_short || "-";
};
